import {datetimeFormatter} from '@hconnect/uikit'
import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {DetailsCard, CardHeader, Button, Timeline} from '@hm/fundamental'
import {mdiClose} from '@mdi/js'
import {Add} from '@mui/icons-material'
import {Box} from '@mui/material'
import moment from 'moment'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useGetJobsToBeDoneInsights} from '../hooks'
import {useLayoutStyles} from '../styles'
import {JobsToBeDoneInsightDetails, JobsToBeDoneTaskWithContext} from '../types'

import {JtbdInsightDetails} from './JtbdInsightDetails'

type Props = {
  onCancel: () => void
  plantUpmId: string
  task: JobsToBeDoneTaskWithContext
  timezone: string
  onAddInsightClick?: () => void
  onInsightClick: (insight: JobsToBeDoneInsightDetails) => void
  isEditAllowed: boolean
  insightQueryParams?: {fromDate?: string; toDate?: string}
}

export const JtbdDetails = ({
  task,
  plantUpmId,
  onCancel,
  timezone,
  onAddInsightClick,
  isEditAllowed,
  insightQueryParams,
  onInsightClick,
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {classes} = useLayoutStyles()

  const {data} = useGetJobsToBeDoneInsights(
    plantUpmId,
    task.jobToBeDoneId,
    task.activityId,
    task.id,
    timezone,
    insightQueryParams
  )

  const insights = data?.insights || []

  const timelineItems = insights.map((insight) => {
    const createdAtFormatted = datetimeFormatter(moment(insight.createdAt), timezone)
    const editedAtFormatted = insight.lastUpdatedAt
      ? datetimeFormatter(moment(insight.lastUpdatedAt), timezone)
      : null

    return {
      id: insight.id,
      time: createdAtFormatted,
      title: insight.createdBy.name,
      details: (
        <JtbdInsightDetails
          insight={insight}
          editedAtFormatted={editedAtFormatted}
          onClick={() => onInsightClick(insight)}
        />
      ),
      showDetails: true
    }
  })

  return (
    <DetailsCard>
      <CardHeader
        containerClassname={classes.sideCardHeader}
        aside={<Button onClick={onCancel} variant="tertiary" icon={mdiClose} />}
      >
        {task.title}
      </CardHeader>
      {isEditAllowed && onAddInsightClick && (
        <Button
          onClick={onAddInsightClick}
          icon={<Add />}
          variant="primary"
          data-cy="create-insight-button"
          className={classes.createNewInsightButton}
        >
          {t('jobsToBeDone.form.title')}
        </Button>
      )}
      <Box
        sx={{
          cursor: 'pointer',
          '& > div > div:hover': {
            backgroundColor: customThemeConstants().palette.containerBackgroundHover
          }
        }}
      >
        <Timeline items={timelineItems} />
      </Box>
    </DetailsCard>
  )
}
